import { createApp } from 'vue';
import VueI18n from './locals';
import App from './App.vue';
import router from './router';
import store from './store';

import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';
import '@/assets/scss/index.scss';
import zhCn from 'element-plus/dist/locale/zh-cn.mjs';
import { startPeriodicCheck } from '@/utils/versionUpdata.js'
import * as ElementPlusIconsVue from '@element-plus/icons-vue';
const app = createApp(App);
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component);
}

const root = document.querySelector(':root') as HTMLElement;
for (let index = 12; index < 38; index++) {
  if (store.getters.getLanguageValue == 'en') {
    root.style.setProperty(
      '--font' + index,
      index - 2 <= 11 ? 12 + 'px' : index - 2 + 'px'
    );
  } else {
    root.style.setProperty('--font' + index, index + 'px');
  }
}
app.use(ElementPlus, {
  size: 'small',
  zIndex: 3000,
  locale: zhCn,
});
startPeriodicCheck()
app.use(store).use(router).use(VueI18n).mount('#app');
